// extracted by mini-css-extract-plugin
export default {"modalBody":"ParticipantsModal__modalBody___RM1D7","footerActions":"ParticipantsModal__footerActions___p1Pks"};